import { render, staticRenderFns } from "./DeletedKokukbanList.vue?vue&type=template&id=c1b7c36c&scoped=true&"
import script from "./DeletedKokukbanList.vue?vue&type=script&lang=js&"
export * from "./DeletedKokukbanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b7c36c",
  null
  
)

export default component.exports